import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import { convertToString, IntlMsgShape } from 'helpers/consts';
import './style.scss';

interface IProps {
  alt: string | IntlMsgShape;
  className?: string;
  hasGradient?: boolean;
  height?: number | string;
  onClick?: React.MouseEventHandler<HTMLImageElement> | undefined;
  src: string;
  width?: number | string;
}

export const VisualTileSkeleton = ({
  alt,
  className,
  hasGradient = false,
  height,
  onClick,
  src,
  width = '100%',
}: IProps) => {
  const [resourceLoaded, setResourceLoaded] = useState(false);
  const { formatMessage } = useIntl();

  const altMessage = convertToString(alt, formatMessage);

  const handleImageLoad = () => {
    setResourceLoaded(true);
  };

  return (
    <div className="VisualTileSkeleton">
      <div
        data-testid="placeholder"
        className="VisualTileSkeleton__placeholder"
        style={{
          display: resourceLoaded ? 'none' : 'block',
          width,
          height: height || '100%',
        }}
      />

      <img
        className={className}
        src={src}
        alt={altMessage}
        onLoad={handleImageLoad}
        onClick={onClick}
        style={{
          objectFit: 'cover',
          opacity: resourceLoaded ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
          width,
          height: height || 'auto',
        }}
      />
      {hasGradient && resourceLoaded && (
        <div
          data-testid="bottom-image-gradient"
          className="VisualTileSkeleton__gradientOverlay"
        />
      )}
    </div>
  );
};

export default VisualTileSkeleton;
